<template>
    <asset-crud kind="control" />
</template>

<script>
    import AssetCrud from './components/AssetCrud'
    export default { name: 'pageAssetControlData', components: { AssetCrud } }
</script>
